import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { ImpressionEtiquetteTemplateModule } from './impression-etiquette-template/impression-etiquette-template.module';

import { ImpressionEtiquetteComponent } from './impression-etiquette.component';

@NgModule({
    declarations: [
        ImpressionEtiquetteComponent,
    ],
    imports: [
        MatDialogModule,
        ImpressionEtiquetteTemplateModule,
    ],
    exports: [
        ImpressionEtiquetteComponent,
    ]
})
export class ImpressionEtiquetteModule{}
